export interface LocaleData {
  [key: string]: string;
}

/** 中文 */
export const zhCN: LocaleData = {
  title: '手势控制 3D 太阳系',
  loading: '正在初始化...',
  gestureInitializing: '🖐️ 正在初始化手势识别...',
  gestureEnabled: '✅ 手势控制已启用',
  gestureDisabled: '🖱️ 已切换到鼠标模式',
  gestureFailed: '❌ 无法启动手势控制（请检查摄像头权限）',
  mouseMode: '🖱️ 鼠标模式',
  gestureMode: '🖐️ 手势控制已启用',
  hintBase: '| 空格暂停 | +/-调速 | 1-9选行星 | G切换手势',
  pause: '⏸️ 已暂停',
  resume: '▶️ 继续运行',
  speedUp: '⏩ 时间加速',
  speedDown: '⏪ 时间减速',
  resetView: '🔄 视角已重置',
  pinchSelect: '✋ 已选取：',
  zoomIn: '🔍 放大',
  zoomOut: '🔍 缩小',
  noHand: '👀 未检测到手部，请将手放在摄像头前',
  helpTitle: '操作指南',
  helpMouse: '鼠标/触摸：\n  左键拖拽 - 旋转视角\n  滚轮 - 缩放\n  点击行星 - 查看信息',
  helpKeyboard: '键盘：\n  1-9 - 聚焦行星\n  空格 - 暂停/继续\n  +/- - 加速/减速\n  R - 重置视角\n  G - 切换手势\n  H - 显示帮助',
  helpGesture: '手势（需摄像头）：\n  五指张开 - 选取行星（可指向不同星球）\n  大拇指朝上 - 下一个行星\n  大拇指朝下 - 上一个行星\n  双手靠近/远离 - 缩放\n  剪刀手（V形） - 重置视角\n  食指指向左 - 减速\n  食指指向右 - 加速',
  planetInfo: '{name}\n半径：{radius} km\n轨道半径：{orbitAU} AU\n公转周期：{period} 天\n自转周期：{rotation} 小时\n质量：{mass} 地球质量\n重力：{gravity} 地球重力\n表面温度：{temp} °C\n卫星数量：{moons}\n\n{desc}',
};

/** 英文 */
export const enUS: LocaleData = {
  title: 'Gesture Control 3D Solar System',
  loading: 'Initializing...',
  gestureInitializing: '🖐️ Initializing gesture recognition...',
  gestureEnabled: '✅ Gesture control enabled',
  gestureDisabled: '🖱️ Switched to mouse mode',
  gestureFailed: '❌ Cannot start gesture control (check camera permission)',
  mouseMode: '🖱️ Mouse mode',
  gestureMode: '🖐️ Gesture control enabled',
  hintBase: '| Space=pause | +/-=speed | 1-9=select | G=toggle gesture',
  pause: '⏸️ Paused',
  resume: '▶️ Resumed',
  speedUp: '⏩ Time speed up',
  speedDown: '⏪ Time slow down',
  resetView: '🔄 View reset',
  pinchSelect: '✋ Selected: ',
  zoomIn: '🔍 Zoom in',
  zoomOut: '🔍 Zoom out',
  noHand: '👀 No hand detected, please show your hand to camera',
  helpTitle: 'Controls',
  helpMouse: 'Mouse/Touch:\n  Drag - Rotate\n  Scroll - Zoom\n  Click - Select planet',
  helpKeyboard: 'Keyboard:\n  1-9 - Focus planet\n  Space - Pause/Resume\n  +/- - Speed up/down\n  R - Reset view\n  G - Toggle gesture\n  H - Show help',
  helpGesture: 'Gestures (need camera):\n  Open palm - Select planet (point anywhere)\n  Thumb up - Next planet\n  Thumb down - Prev planet\n  Two hands closer/farther - Zoom\n  Scissors(V sign) - Reset view\n  Point left - Slow down\n  Point right - Speed up',
  planetInfo: '{name}\nRadius: {radius} km\nOrbit: {orbitAU} AU\nOrbital period: {period} days\nRotation: {rotation} hours\nMass: {mass} Earth\nGravity: {gravity} g\nTemperature: {temp} °C\nMoons: {moons}\n\n{desc}',
};

/** 获取当前语言包 */
let currentLocale: LocaleData = zhCN;

export function t(key: string, params?: Record<string, string | number>): string {
  let text = currentLocale[key] || key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(`{${k}}`, String(v));
    }
  }
  return text;
}

/** 切换语言 */
export function setLocale(locale: 'zh' | 'en') {
  currentLocale = locale === 'en' ? enUS : zhCN;
}

/** 获取当前语言 */
export function getLocale(): 'zh' | 'en' {
  return currentLocale === enUS ? 'en' : 'zh';
}
